import HttpService from "@/utils/httpData"

export const saveLessonClassSchool = params => {
    let apiEndpoint = `LessonClassSchool/Create`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const saveExcerciseClassSchool = params => {
    let apiEndpoint = `LessonClassSchool/CreateExcerciseClassSchool`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const createExcercisePdf = params => {
    let apiEndpoint = `LessonClassSchool/CreateExcercisePdf`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getDetail = id => {
    let apiEndpoint = `LessonClassSchool/detail?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getDetailExcercise = id => {
    let apiEndpoint = `LessonClassSchool/GetDetailExcercise?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const GetDetailExcerciseDoWork = params => {
    let apiEndpoint = `LessonClassSchool/GetDetailExcerciseDoWork`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const listLessonClassSchool = params => {
    let apiEndpoint = `LessonClassSchool/List`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListExcerciseClassSchool = params => {
    let apiEndpoint = `LessonClassSchool/GetListExcerciseClassSchool`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const changePublicLessonClassSchool = params => {
    let apiEndpoint = `LessonClassSchool/ChangePublicLessonClassSchool`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const deleteLessonClassSchool = id => {
    let apiEndpoint = `LessonClassSchool/Delete?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListElectronicLectureByCurrentUser = (params) => {
    let apiEndpoint = `LessonClassSchool/GetListElectronicLectureByCurrentUser`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


export const saveLessonPlaningClassSchool = params => {
    let apiEndpoint = `LessonClassSchool/CreateLessonPlaning`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const assignExamIdClassSchool = params => {
    let apiEndpoint = `LessonClassSchool/AssignExamIdClassSchool`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const assignLessonClassSchool = params => {
    let apiEndpoint = `LessonClassSchool/AssignLessonClassSchool`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListlLessonAssign = params => {
    let apiEndpoint = `LessonClassSchool/GetListlLessonAssign`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
//
export const getListExcerciseAssign = params => {
    let apiEndpoint = `LessonClassSchool/GetListExcerciseAssign`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


export const getListClassSchoolGroupAssignLesson = params => {
    let apiEndpoint = `LessonClassSchool/GetListClassSchoolGroupAssignLesson`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListClassSchoolGroupAssignExcercise = params => {
    let apiEndpoint = `LessonClassSchool/GetListClassSchoolGroupAssignExcercise`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


export const getListUserAssingLessonByGroupId = (params) => {
    let apiEndpoint = `LessonClassSchool/GetListUserAssingLessonByGroupId`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListUserAssingExcerciseByGroupId = (params) => {
    let apiEndpoint = `LessonClassSchool/GetListUserAssingExcerciseByGroupId`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


export const recoveryLessonClassSchoolId = (params) => {
    let apiEndpoint = `LessonClassSchool/RecoveryLessonClassSchoolId`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const recoveryLessonGroupId = (params) => {
    let apiEndpoint = `LessonClassSchool/RecoveryLessonGroupId`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const GetListLessonPlaning = (params) => {
    let apiEndpoint = `LessonClassSchool/GetListLessonPlaning`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getListUserAssingLessonByClassSchoolId = (params) => {
    let apiEndpoint = `LessonClassSchool/GetListUserAssingLessonByClassSchoolId`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getListUserAssingExcerciseByClassSchoolId = (params) => {
    let apiEndpoint = `LessonClassSchool/GetListUserAssingExcerciseByClassSchoolId`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
//

export const GetListElectronicLecture = (params) => {
    let apiEndpoint = `LessonClassSchool/GetListElectronicLecture`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const SetDurationClassGroupAssign = (params) => {
    let apiEndpoint = `LessonClassSchool/SetDurationClassGroupAssign`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const changeOrderlessonPlaning = (params) => {
    let apiEndpoint = `LessonClassSchool/ChangeOrderlessonPlaning`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListQuestionBank = params => {
    let apiEndpoint = `LessonClassSchool/getListQuestionBank`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


export const deleteExcerciseClassSchool = id => {
    let apiEndpoint = `LessonClassSchool/DeleteExcerciseClassSchool?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const moveExcerciseOutFolder = id => {
    let apiEndpoint = `LessonClassSchool/MoveExcerciseOutFolder?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListBankExamExcercise = params => {
    let apiEndpoint = `LessonClassSchool/GetListBankExamExcercise`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListQuestionByExamId = id => {
    let apiEndpoint = `LessonClassSchool/GetListQuestionByExamId?examId=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const GetQuestionByDoc = params => {
    let apiEndpoint = `LessonClassSchool/GetQuestionByDoc`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const SaveAndAssignExcerciseClassSchool = params => {
    let apiEndpoint = `LessonClassSchool/SaveAndAssignExcerciseClassSchool`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getQuestionFilePDF = params => {
    let apiEndpoint = `LessonClassSchool/GetQuestionFilePDF`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListExcerciseNotScore = params => {
    let apiEndpoint = `LessonClassSchool/GetListExcerciseNotScore`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListAnswerMember = params => {
    let apiEndpoint = `LessonClassSchool/GetListAnswerMember`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const recoveryAssignLessonClassSchool = params => {
    let apiEndpoint = `LessonClassSchool/RecoveryAssignLessonClassSchool`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const changeOrderLesson = params => {
    let apiEndpoint = `LessonClassSchool/ChangeOrderLesson`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}